<template>
  <div class="home-view">
    <!-- Header Component (Combined MainHeader and MainNavbar) -->
    <Header />
  
    <!-- Main Content Area -->
    <main>
      <HomeContent />
    </main>
  
    <!-- Footer Component -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import HomeContent from '@/components/HomeContent.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'HomeView',
  components: {
    Header,
    HomeContent,
    Footer
  }
};
</script>

<style scoped>
.home-view {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

main {
  flex: 1 0 auto;
  padding-top: 80px; /* Add padding for fixed header */
}
</style>